
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1BivY", function(module, exports) {

$parcel$export(module.exports, "useIsDropdownOpen", () => $bad5c2f408aed040$export$f23a75298e125425);
$parcel$export(module.exports, "CreateBranchDropdown", () => $bad5c2f408aed040$export$2cbffad71321760a);
$parcel$export(module.exports, "default", () => $bad5c2f408aed040$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80xRm = parcelRequire("80xRm");

var $1Q3jn = parcelRequire("1Q3jn");

var $5DgXR = parcelRequire("5DgXR");

var $1WryD = parcelRequire("1WryD");

var $awZZu = parcelRequire("awZZu");

var $4F5bb = parcelRequire("4F5bb");

var $kkiGo = parcelRequire("kkiGo");

var $lgMTT = parcelRequire("lgMTT");

var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $dPMMf = parcelRequire("dPMMf");

var $dTocu = parcelRequire("dTocu");

var $bmoS1 = parcelRequire("bmoS1");

var $1LCJW = parcelRequire("1LCJW");

var $3EmVH = parcelRequire("3EmVH");

var $cNe2t = parcelRequire("cNe2t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $bNexr = parcelRequire("bNexr");

var $4doLC = parcelRequire("4doLC");

var $8q7lT = parcelRequire("8q7lT");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $kvPhw = parcelRequire("kvPhw");

var $5L1GF = parcelRequire("5L1GF");

var $6Wpie = parcelRequire("6Wpie");

var $aKj6s = parcelRequire("aKj6s");

var $bNTaA = parcelRequire("bNTaA");
const $bad5c2f408aed040$var$linkItemStyles = null;
const $bad5c2f408aed040$var$getAvatarSrc = (iconUrl, iconClass)=>{
    if (iconUrl !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl
    });
    if (iconClass === 'bitbucket') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.BitbucketIcon), {
        appearance: "brand",
        size: "small"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bad5c2f408aed040$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        label: "",
        appearance: "blueBold",
        shape: "square",
        size: "16"
    }));
};
const $bad5c2f408aed040$export$f23a75298e125425 = (isOpen = false)=>(0, $eJOHy.useState)(isOpen);
const $bad5c2f408aed040$var$CreateBranchDropdownInner = ({ createBranchTargets: createBranchTargets, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideCreateBranchLinks: hideCreateBranchLinks = false })=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $bad5c2f408aed040$export$f23a75298e125425();
    const [isBranchConfigOpen, setIsBranchConfigOpen] = (0, $eJOHy.useState)(false);
    const previousOpen = (0, $eJOHy.useRef)(false);
    const [{ isLoading: isLoading }, { getUserConfigBranchData: getUserConfigBranchData, setBranchData: setBranchData }] = (0, $5L1GF.useBranchCommandBuilderStore)();
    const configButtonRef = (0, $eJOHy.useRef)(null);
    const accountId = (0, $8q7lT.useAccountId)();
    const issueKey = (0, $bmoS1.useIssueKey)(); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issueId = (0, $7jTnu.fg)('relay-migration-issue-fields-summary') ? (0, $bmoS1.useIssueId)() : undefined;
    const [{ value: issueType }] = (0, $1LCJW.useIssueTypeField)({
        issueKey: issueKey
    });
    const [{ value: issueSummary }] = (0, $3EmVH.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const menuGroupRef = (0, $eJOHy.useRef)(null);
    const [activeItemId, setActiveItemId] = (0, $eJOHy.useState)(null);
    const handleOnClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'updateBranchNameFormatButton'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        setIsBranchConfigOpen(true);
    };
    const handleOnHover = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'updateBranchNameFormatButton'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
    };
    (0, $eJOHy.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            if (isOpen) {
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'createBranchDropdown');
                setBranchData({
                    issueKey: issueKey,
                    issueSummary: issueSummary || '',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    issueType: issueType?.name || '',
                    projectKey: projectKey
                });
                getUserConfigBranchData(accountId);
                setTimeout(()=>{
                    if (!isBranchConfigOpen && menuGroupRef.current && (0, $7jTnu.fg)('dev_details_add_focus_to_list')) {
                        const firstMenuItem = menuGroupRef.current?.querySelector('[role="menuitem"]');
                        if (firstMenuItem) {
                            firstMenuItem.focus();
                            setActiveItemId(firstMenuItem.getAttribute('data-testid'));
                        }
                    }
                }, 0);
            } else {
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'createBranchDropdown');
                isBranchConfigOpen && setIsBranchConfigOpen(false);
            }
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        createBranchTargets,
        isOpen,
        onOpenDropdown,
        accountId,
        getUserConfigBranchData,
        setBranchData,
        issueKey,
        issueSummary,
        issueType?.name,
        projectKey,
        isBranchConfigOpen
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (!(0, $7jTnu.fg)('dev_details_add_focus_to_list')) return;
        if (!menuGroupRef.current) return;
        const menuItems = Array.from(menuGroupRef.current.querySelectorAll('[role="menuitem"]'));
        if (menuItems.length === 0) return;
        const currentIndex = menuItems.findIndex((item)=>item === globalThis.document?.activeElement);
        switch(event.key){
            case 'ArrowDown':
                {
                    event.preventDefault();
                    const nextIndex = currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0;
                    menuItems[nextIndex].focus(); // Update active item tracking using data-testid
                    setActiveItemId(menuItems[nextIndex].getAttribute('data-testid') || null);
                    break;
                }
            case 'ArrowUp':
                {
                    event.preventDefault();
                    const prevIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
                    menuItems[prevIndex].focus(); // Update active item tracking using data-testid
                    setActiveItemId(menuItems[prevIndex].getAttribute('data-testid') || null);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (!isBranchConfigOpen && configButtonRef.current) configButtonRef.current.focus();
    }, [
        isBranchConfigOpen
    ]);
    const createBranchDropdownItems = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(createBranchTargets, 'name').map(({ iconClass: iconClass, iconUrl: iconUrl, name: remoteAppName, applicationType: applicationType, url: remoteAppUrl }, index)=>remoteAppUrl !== null && remoteAppUrl !== undefined && ((0, $7jTnu.fg)('dev_details_add_focus_to_list') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $bad5c2f408aed040$var$listStyles,
                as: "li",
                role: "none",
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
                key: remoteAppUrl,
                href: remoteAppUrl,
                role: "menuitem",
                tabIndex: -1,
                onClick: ()=>{
                    setIsOpen(false);
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'scmCreateBranchLink', {
                        redirectToScmProviderPage: true,
                        scmProviderType: applicationType
                    });
                },
                target: "_blank",
                rel: "noreferrer noopener",
                id: `development-summary-branch.ui.create-branch-dropdown.link-item--${index}`,
                testId: `development-summary-branch.ui.create-branch-dropdown.link-item--${index}`,
                xcss: $bad5c2f408aed040$var$anchorStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $bad5c2f408aed040$var$avatarStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, $bad5c2f408aed040$var$getAvatarSrc(iconUrl, iconClass)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $bad5c2f408aed040$var$labelStyles
            }, formatMessage((0, $bNTaA.default).createBranchMessage, {
                remoteAppName: remoteAppName
            }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
                key: remoteAppUrl,
                href: remoteAppUrl,
                onClick: ()=>{
                    setIsOpen(false);
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'scmCreateBranchLink', {
                        redirectToScmProviderPage: true,
                        scmProviderType: applicationType
                    });
                },
                iconBefore: $bad5c2f408aed040$var$getAvatarSrc(iconUrl, iconClass),
                target: "_blank",
                rel: "noreferrer noopener",
                testId: "development-summary-branch.ui.create-branch-dropdown.link-item",
                className: (0, $hcewu.default)([
                    "_1tke1wug"
                ])
            }, formatMessage((0, $bNTaA.default).createBranchMessage, {
                remoteAppName: remoteAppName
            })))), [
        createBranchTargets,
        formatMessage,
        createAnalyticsEvent,
        setIsOpen
    ]);
    const showCreateBranchLinkSection = !hideCreateBranchLinks && createBranchTargets.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        id: "create-branch-dropdown",
        zIndex: (0, $dPMMf.layers).modal + 1,
        placement: "bottom-end",
        shouldFlip: true,
        messageId: "development-summary-branch.ui.create-branch-dropdown.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
            setIsBranchConfigOpen(false);
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$BranchDropdownWidthContainer, {
                "data-testid": "development-summary-branch.ui.create-branch-dropdown.branch-dropdown-width-container"
            }, isBranchConfigOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Wpie.default), {
                setIsBranchConfigOpen: setIsBranchConfigOpen
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Q3jn.default), {
                returnFocus: true
            }, showCreateBranchLinkSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: menuGroupRef,
                role: "menu",
                testId: "development-summary-branch.ui.create-branch-dropdown.menu-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                "aria-activedescendant": activeItemId || undefined,
                testId: "development-summary-branch.ui.create-branch-dropdown.create-source-branch-section",
                title: formatMessage((0, $bNTaA.default).branchTargetsGroupTitle)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$BranchDropdownScrollContainer, {
                tabIndex: 0,
                role: "menu",
                onKeyDown: handleKeyDown
            }, createBranchDropdownItems), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
                action: "shown",
                actionSubject: "createBranchLinkList"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                hasSeparator: showCreateBranchLinkSection,
                testId: (0, $kvPhw.GIT_COMMAND_SECTION_TEST_ID)
            }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4doLC.DevSummaryCreateBranchPopupSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$GitCommandSectionHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$GitCommandTitle, {
                "data-testid": "development-summary-branch.ui.create-branch-dropdown.git-command-title"
            }, formatMessage((0, $bNTaA.default).gitCommandGroupTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: formatMessage((0, $bNTaA.default).configurableBranchCreateButtonLabel),
                position: "top",
                testId: "development-summary-branch.ui.create-branch-dropdown.tooltip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$ConfigButton, {
                showCreateBranchLinkSection: true,
                ref: configButtonRef,
                onClick: handleOnClick,
                onMouseEnter: handleOnHover,
                "data-testid": "development-summary-branch.ui.create-branch-dropdown.config-button"
            }, (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $bNTaA.default).configurableBranchCreateButtonLabel)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkiGo))), {
                label: formatMessage((0, $bNTaA.default).configurableBranchCreateButtonLabel),
                LEGACY_size: "small"
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$FauxDropdownItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aKj6s.default), null))))))
    });
};
const $bad5c2f408aed040$export$2cbffad71321760a = ({ createBranchTargets: createBranchTargets, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideCreateBranchLinks: hideCreateBranchLinks = false })=>{
    const scmProviderTypes = (0, $eJOHy.useMemo)(()=>createBranchTargets.map((target)=>target.applicationType), [
        createBranchTargets
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            scmProviderTypes: scmProviderTypes,
            singleScmProvider: createBranchTargets.length === 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bad5c2f408aed040$var$CreateBranchDropdownInner, {
        createBranchTargets: createBranchTargets,
        onOpenDropdown: onOpenDropdown,
        getDropdownTrigger: getDropdownTrigger,
        hideCreateBranchLinks: hideCreateBranchLinks
    }));
};
var $bad5c2f408aed040$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bad5c2f408aed040$export$2cbffad71321760a;
const $bad5c2f408aed040$var$FauxDropdownItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3v47k _n3tdu2gc _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bad5c2f408aed040$var$BranchDropdownScrollContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _c71l10bg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bad5c2f408aed040$var$BranchDropdownWidthContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbrdnh",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bad5c2f408aed040$var$ConfigButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _2rko1y44 _v5641v24 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _bfhk18uv _80omtlke _vwz4idpf _o7kskn6i _irr315ej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bad5c2f408aed040$var$GitCommandSectionHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3v47k _n3tdidpf _19bvv47k _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bad5c2f408aed040$var$GitCommandTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _1p1dangw _ect41gqc _k48pmoej _19pku2gc _2hwxidpf _otyru2gc _18u0idpf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $bad5c2f408aed040$var$boxStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)",
    borderRadius: 'border.radius.100',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $bad5c2f408aed040$var$anchorStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'nowrap',
    color: 'color.text',
    backgroundColor: 'elevation.surface',
    textDecoration: 'none',
    paddingInline: 'space.200',
    paddingBlock: 'space.100',
    margin: 'space.050',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed',
        textDecoration: 'none'
    }
});
const $bad5c2f408aed040$var$listStyles = (0, $1DXK0.xcss)({
    listStyle: 'none',
    padding: '0'
});
const $bad5c2f408aed040$var$avatarStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: 'space.150',
    width: '100%'
});
const $bad5c2f408aed040$var$labelStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("4doLC", function(module, exports) {

$parcel$export(module.exports, "DevSummaryCreateBranchPopupSkeleton", () => $51b55c28cf2da6a9$export$777a1ef0acbb8d79);
/* DevSummaryCreateBranchPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $3BHHy = parcelRequire("3BHHy");
const $51b55c28cf2da6a9$var$containerStyles = null;
const $51b55c28cf2da6a9$export$777a1ef0acbb8d79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "skeletons.ui.dev-summary-create-branch-popup.div",
        className: (0, $hcewu.default)([
            "_ca0qze3t _u5f3v47k _n3tdze3t _19bvv47k _4t3ir7x6 _1v7tn7od _1ieon7od _1vx6n7od _3glbn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3BHHy)))
    }));

});
parcelRegister("3BHHy", function(module, exports) {
module.exports = new URL("dev-summary-create-branch-popup.tpl.37139a68.svg", import.meta.url).toString();

});


parcelRegister("kvPhw", function(module, exports) {

$parcel$export(module.exports, "UPDATE_BRANCH_NAME_FORMAT_TITLE_TEST_ID", () => $b4ef222fb3024648$export$b7fad45c54770da);
$parcel$export(module.exports, "PREVIEW_TITLE_TEST_ID", () => $b4ef222fb3024648$export$22ee487ea97a4c);
$parcel$export(module.exports, "RESET_BUTTON_TEST_ID", () => $b4ef222fb3024648$export$486dec2b953e5ae);
$parcel$export(module.exports, "CANCEL_BUTTON_TEST_ID", () => $b4ef222fb3024648$export$3436ddf8bf2120bc);
$parcel$export(module.exports, "SAVE_BUTTON_TEST_ID", () => $b4ef222fb3024648$export$ed485395681ff340);
$parcel$export(module.exports, "COPY_PAGE_GIT_COMMAND_LENGTH_ERROR_MESSAGE_TEST_ID", () => $b4ef222fb3024648$export$6988540077064b73);
$parcel$export(module.exports, "SAVE_ERROR_MESSAGE_TEST_ID", () => $b4ef222fb3024648$export$3a82a302bc1421a9);
$parcel$export(module.exports, "PROPERTY_KEY", () => $b4ef222fb3024648$export$bb10a02fc2feb574);
$parcel$export(module.exports, "GIT_COMMAND_SECTION_TEST_ID", () => $b4ef222fb3024648$export$93876e35991f382d);
$parcel$export(module.exports, "tags", () => $b4ef222fb3024648$export$8b7a896ae75accbf);
$parcel$export(module.exports, "initialTemplates", () => $b4ef222fb3024648$export$1f6def93b12b1d48);
$parcel$export(module.exports, "TAB", () => $b4ef222fb3024648$export$f1c9dd0f5207dd5e);
$parcel$export(module.exports, "ARROW_DOWN", () => $b4ef222fb3024648$export$59f214baefff6196);
$parcel$export(module.exports, "ARROW_UP", () => $b4ef222fb3024648$export$8188339dbe6c99c4);
$parcel$export(module.exports, "ARROW_LEFT", () => $b4ef222fb3024648$export$8d4f84cc5dc5fc15);
$parcel$export(module.exports, "ARROW_RIGHT", () => $b4ef222fb3024648$export$e9510a4613bb01df);
$parcel$export(module.exports, "ENTER", () => $b4ef222fb3024648$export$806b905ec7df742f);
$parcel$export(module.exports, "BACKSPACE", () => $b4ef222fb3024648$export$acae31b32a99bba9);
$parcel$export(module.exports, "DELETE", () => $b4ef222fb3024648$export$4bd2facc4a3e6aa1);
$parcel$export(module.exports, "TAB_KEY_CODE", () => $b4ef222fb3024648$export$c8fc15cbe86018cf);
$parcel$export(module.exports, "ARROW_DOWN_KEY_CODE", () => $b4ef222fb3024648$export$ef4126220d897037);
$parcel$export(module.exports, "ARROW_UP_KEY_CODE", () => $b4ef222fb3024648$export$350d8b99a00c926e);
$parcel$export(module.exports, "ARROW_LEFT_KEY_CODE", () => $b4ef222fb3024648$export$e774cc0768ea4dc1);
$parcel$export(module.exports, "ARROW_RIGHT_KEY_CODE", () => $b4ef222fb3024648$export$31ed5928f4dcb259);
$parcel$export(module.exports, "ENTER_KEY_CODE", () => $b4ef222fb3024648$export$772f5b3bcf01463);
$parcel$export(module.exports, "BACKSPACE_KEY_CODE", () => $b4ef222fb3024648$export$707d117a1ef29221);
$parcel$export(module.exports, "DELETE_KEY_CODE", () => $b4ef222fb3024648$export$229ec1b1cfee860b);
$parcel$export(module.exports, "GIT_COMMAND_MAX_LENGTH", () => $b4ef222fb3024648$export$4f8e512aaddfeb04);
$parcel$export(module.exports, "GIT_CHECKOUT_NEW_BRANCH", () => $b4ef222fb3024648$export$1817f9c591be5d87);
$parcel$export(module.exports, "ERROR", () => $b4ef222fb3024648$export$103bedf43ba882db);
$parcel$export(module.exports, "WARNING", () => $b4ef222fb3024648$export$64fdd419ec8dbc36);
$parcel$export(module.exports, "FORBIDDEN_GIT_BRANCH_EXPRESSIONS", () => $b4ef222fb3024648$export$4f363a1643a5c272);

var $3M949 = parcelRequire("3M949");
const $b4ef222fb3024648$export$b7fad45c54770da = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.section-title-update-branch-name-format';
const $b4ef222fb3024648$export$22ee487ea97a4c = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.section-title-preivew';
const $b4ef222fb3024648$export$486dec2b953e5ae = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.reset-button';
const $b4ef222fb3024648$export$3436ddf8bf2120bc = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.button-cancel';
const $b4ef222fb3024648$export$ed485395681ff340 = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.button-save';
const $b4ef222fb3024648$export$6988540077064b73 = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.git-command-error-message-copy-page';
const $b4ef222fb3024648$export$3a82a302bc1421a9 = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.save-error-message';
const $b4ef222fb3024648$export$bb10a02fc2feb574 = 'create-branch-config';
const $b4ef222fb3024648$export$93876e35991f382d = 'development-summary-branch.ui.create-branch-dropdown.git-command-section';
const $b4ef222fb3024648$export$8b7a896ae75accbf = [
    (0, $3M949.PlaceholderEnum).ISSUE_KEY,
    (0, $3M949.PlaceholderEnum).ISSUE_SUMMARY,
    (0, $3M949.PlaceholderEnum).ISSUE_SUMMARY_SHORT,
    (0, $3M949.PlaceholderEnum).ISSUE_TYPE,
    (0, $3M949.PlaceholderEnum).PROJECT_KEY
];
const $b4ef222fb3024648$export$1f6def93b12b1d48 = [
    {
        type: (0, $3M949.BranchTemplateType).TEXT,
        value: ''
    },
    {
        type: (0, $3M949.BranchTemplateType).PLACEHOLDER,
        value: (0, $3M949.PlaceholderEnum).ISSUE_KEY
    },
    {
        type: (0, $3M949.BranchTemplateType).TEXT,
        value: '-'
    },
    {
        type: (0, $3M949.BranchTemplateType).PLACEHOLDER,
        value: (0, $3M949.PlaceholderEnum).ISSUE_SUMMARY
    },
    {
        type: (0, $3M949.BranchTemplateType).TEXT,
        value: ''
    }
];
const $b4ef222fb3024648$export$f1c9dd0f5207dd5e = 'Tab';
const $b4ef222fb3024648$export$59f214baefff6196 = 'ArrowDown';
const $b4ef222fb3024648$export$8188339dbe6c99c4 = 'ArrowUp';
const $b4ef222fb3024648$export$8d4f84cc5dc5fc15 = 'ArrowLeft';
const $b4ef222fb3024648$export$e9510a4613bb01df = 'ArrowRight';
const $b4ef222fb3024648$export$806b905ec7df742f = 'Enter';
const $b4ef222fb3024648$export$acae31b32a99bba9 = 'Backspace';
const $b4ef222fb3024648$export$4bd2facc4a3e6aa1 = 'Delete';
const $b4ef222fb3024648$export$c8fc15cbe86018cf = 9;
const $b4ef222fb3024648$export$ef4126220d897037 = 40;
const $b4ef222fb3024648$export$350d8b99a00c926e = 38;
const $b4ef222fb3024648$export$e774cc0768ea4dc1 = 37;
const $b4ef222fb3024648$export$31ed5928f4dcb259 = 39;
const $b4ef222fb3024648$export$772f5b3bcf01463 = 13;
const $b4ef222fb3024648$export$707d117a1ef29221 = 8;
const $b4ef222fb3024648$export$229ec1b1cfee860b = 46;
const $b4ef222fb3024648$export$4f8e512aaddfeb04 = 250;
const $b4ef222fb3024648$export$1817f9c591be5d87 = 'git checkout -b';
const $b4ef222fb3024648$export$103bedf43ba882db = 'error';
const $b4ef222fb3024648$export$64fdd419ec8dbc36 = 'warning';
const $b4ef222fb3024648$export$4f363a1643a5c272 = // We need control character pattern matching to comply with Git's ref format
// eslint-disable-next-line no-control-regex
/(^|[/.])([/.]|$)|^@$|@{|[\x00-\x20\x7f~^:?*;"'`&|$()!\][\\]|\.lock(\/|$)|\s/g;

});
parcelRegister("3M949", function(module, exports) {

$parcel$export(module.exports, "PlaceholderEnum", () => $d45d0d2ea5ca6f2c$export$83a26ecbeb7da185);
$parcel$export(module.exports, "BranchTemplateType", () => $d45d0d2ea5ca6f2c$export$8aa063a04e39c752);
const $d45d0d2ea5ca6f2c$export$83a26ecbeb7da185 = {
    ISSUE_KEY: 'issueKey',
    ISSUE_SUMMARY: 'issueSummary',
    ISSUE_SUMMARY_SHORT: 'issueSummaryShort',
    ISSUE_TYPE: 'issueType',
    PROJECT_KEY: 'projectKey'
};
const $d45d0d2ea5ca6f2c$export$8aa063a04e39c752 = {
    TEXT: 'TEXT',
    PLACEHOLDER: 'PLACEHOLDER'
};

});


parcelRegister("5L1GF", function(module, exports) {

$parcel$export(module.exports, "useBranchCommandBuilderStore", () => $e38662835acddaf2$export$931a712bc1008381);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $kvPhw = parcelRequire("kvPhw");

var $7gjNa = parcelRequire("7gjNa");
const $e38662835acddaf2$export$e324594224ef24da = {
    setDefaultTemplates: $7gjNa.setDefaultTemplates,
    setUserEnteredTemplate: $7gjNa.setUserEnteredTemplate,
    setCaretPosition: $7gjNa.setCaretPosition,
    insertPlaceholder: $7gjNa.insertPlaceholder,
    removePlaceholder: $7gjNa.removePlaceholder,
    saveUserConfigBranchData: $7gjNa.saveUserConfigBranchData,
    setInitialState: $7gjNa.setInitialState,
    getUserConfigBranchData: $7gjNa.getUserConfigBranchData,
    setBranchData: $7gjNa.setBranchData,
    setFocusTagIndex: $7gjNa.setFocusTagIndex,
    setRestoreFocus: $7gjNa.setRestoreFocus,
    setEmptyTextStarterTemplates: $7gjNa.setEmptyTextStarterTemplates,
    restoreFocusAfterDeletingAllText: $7gjNa.restoreFocusAfterDeletingAllText,
    setIsGitCommandIncluded: $7gjNa.setIsGitCommandIncluded
};
const $e38662835acddaf2$var$defaultTemplates = Array.from((0, $kvPhw.initialTemplates));
const $e38662835acddaf2$export$62680b65e63e14ec = {
    branchNameTemplate: $e38662835acddaf2$var$defaultTemplates,
    version: 'v2',
    isGitCommandIncluded: true
};
const $e38662835acddaf2$export$d4c72bab9d6cc13a = {
    // React.js: Getting "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
    // we need to update the key of the parent element to fix this issue
    // uniqueKey is used only as a React key, so we hardcode it - it does not need to change between loads
    uniqueKey: 'initial-key',
    writeOnlyTemplates: $e38662835acddaf2$var$defaultTemplates,
    readAndWriteTemplates: $e38662835acddaf2$var$defaultTemplates,
    get originalTemplates () {
        return $e38662835acddaf2$var$defaultTemplates;
    },
    caretPosition: {
        templateIndex: 2,
        characterIndex: 0
    },
    isLoading: false,
    isSaving: false,
    restoreFocus: false,
    saveError: null,
    branchData: {
        issueKey: '',
        issueSummary: '',
        issueType: '',
        projectKey: ''
    },
    focusTagIndex: 0
};
const $e38662835acddaf2$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'branchCommandBuilderStore',
    initialState: $e38662835acddaf2$export$d4c72bab9d6cc13a,
    actions: $e38662835acddaf2$export$e324594224ef24da
});
const $e38662835acddaf2$export$931a712bc1008381 = (0, $iJq0l.createHook)($e38662835acddaf2$export$390f32400eaf98c9);

});
parcelRegister("7gjNa", function(module, exports) {

$parcel$export(module.exports, "getBranchTemplate", () => $e6cbbaf5c0cd93b7$export$514aa7ab9be9e739);
$parcel$export(module.exports, "getBranchSettings", () => $e6cbbaf5c0cd93b7$export$7d4957ca5a2b6c36);
$parcel$export(module.exports, "setInitialState", () => $e6cbbaf5c0cd93b7$export$17a469542330eb1b);
$parcel$export(module.exports, "restoreFocusAfterDeletingAllText", () => $e6cbbaf5c0cd93b7$export$115ba9b4d813d40);
$parcel$export(module.exports, "setEmptyTextStarterTemplates", () => $e6cbbaf5c0cd93b7$export$a56e2c50ad04f20a);
$parcel$export(module.exports, "setDefaultTemplates", () => $e6cbbaf5c0cd93b7$export$306cf5a0989ece24);
$parcel$export(module.exports, "setUserEnteredTemplate", () => $e6cbbaf5c0cd93b7$export$be1c83975a266890);
$parcel$export(module.exports, "setCaretPosition", () => $e6cbbaf5c0cd93b7$export$97ab23b40042f8af);
$parcel$export(module.exports, "insertPlaceholder", () => $e6cbbaf5c0cd93b7$export$93bd7e21ec24d5a4);
$parcel$export(module.exports, "removePlaceholder", () => $e6cbbaf5c0cd93b7$export$2e7311d25c70abda);
$parcel$export(module.exports, "saveUserConfigBranchData", () => $e6cbbaf5c0cd93b7$export$5d8e34360f237a1b);
$parcel$export(module.exports, "getUserConfigBranchData", () => $e6cbbaf5c0cd93b7$export$7ca6c0c3719afbb8);
$parcel$export(module.exports, "setBranchData", () => $e6cbbaf5c0cd93b7$export$76dea67fbc11f21b);
$parcel$export(module.exports, "setFocusTagIndex", () => $e6cbbaf5c0cd93b7$export$23556ac160319730);
$parcel$export(module.exports, "setRestoreFocus", () => $e6cbbaf5c0cd93b7$export$e71e64a53e05e7a4);
$parcel$export(module.exports, "setIsGitCommandIncluded", () => $e6cbbaf5c0cd93b7$export$6004d0b86f5fafd);

var $aXKmr = parcelRequire("aXKmr");

var $kvPhw = parcelRequire("kvPhw");

var $3M949 = parcelRequire("3M949");

var $e1hLY = parcelRequire("e1hLY");

var $fJmA9 = parcelRequire("fJmA9");
const $e6cbbaf5c0cd93b7$var$getPlaceHoldersLength = (template)=>template.filter((item)=>item.type === (0, $3M949.BranchTemplateType).PLACEHOLDER).length;
const $e6cbbaf5c0cd93b7$export$514aa7ab9be9e739 = (branchSettings)=>Array.isArray(branchSettings) ? branchSettings : branchSettings.branchNameTemplate;
const $e6cbbaf5c0cd93b7$export$7d4957ca5a2b6c36 = (branchSettings, isGitCommandIncluded = true)=>Array.isArray(branchSettings) ? {
        branchNameTemplate: branchSettings,
        version: 'v2',
        isGitCommandIncluded: isGitCommandIncluded
    } : branchSettings;
const $e6cbbaf5c0cd93b7$var$getInitialState = (templates)=>{
    const userBranchSettings = $e6cbbaf5c0cd93b7$export$7d4957ca5a2b6c36(templates);
    const { branchNameTemplate: branchNameTemplate } = userBranchSettings;
    const newBranchNameSettings = {};
    const defaultTemplates = Array.from(branchNameTemplate);
    return {
        uniqueKey: (0, $aXKmr.v4)(),
        writeOnlyTemplates: defaultTemplates,
        readAndWriteTemplates: defaultTemplates,
        originalTemplates: defaultTemplates,
        caretPosition: {
            templateIndex: $e6cbbaf5c0cd93b7$var$getPlaceHoldersLength(defaultTemplates),
            characterIndex: 0
        },
        isLoading: false,
        isSaving: false,
        saveError: null,
        focusTagIndex: 0,
        ...newBranchNameSettings
    };
};
const $e6cbbaf5c0cd93b7$export$17a469542330eb1b = (templates)=>({ setState: setState })=>{
        const initialState = $e6cbbaf5c0cd93b7$var$getInitialState(templates);
        setState({
            ...initialState
        });
    };
const $e6cbbaf5c0cd93b7$export$115ba9b4d813d40 = ()=>({ setState: setState, getState: getState })=>{
        const { caretPosition: caretPosition, writeOnlyTemplates: writeOnlyTemplates, readAndWriteTemplates: readAndWriteTemplates } = getState();
        const lastTemplate = readAndWriteTemplates[readAndWriteTemplates.length - 1];
        const isLastTemplateATag = lastTemplate.type === (0, $3M949.BranchTemplateType).PLACEHOLDER;
        if (writeOnlyTemplates.length === readAndWriteTemplates.length + 2) // a tag along with a text has been deleted with BACKSPACE (not DELETE)
        {
            if (caretPosition.templateIndex > 0) setState({
                uniqueKey: (0, $aXKmr.v4)(),
                writeOnlyTemplates: readAndWriteTemplates,
                caretPosition: {
                    templateIndex: caretPosition.templateIndex - 1,
                    characterIndex: 0
                },
                restoreFocus: true
            });
        } else if (readAndWriteTemplates.length % 2 === 0 && isLastTemplateATag) {
            // tag template at the end
            const updatedTemplates = (0, $fJmA9.handleEndTagTemplate)(readAndWriteTemplates);
            setState({
                uniqueKey: (0, $aXKmr.v4)(),
                readAndWriteTemplates: updatedTemplates,
                writeOnlyTemplates: updatedTemplates,
                caretPosition: {
                    templateIndex: caretPosition.templateIndex,
                    characterIndex: 0
                },
                restoreFocus: true
            });
        } else if (readAndWriteTemplates.length % 2 === 0) {
            // even number of templates, insert text between tags
            const updatedTemplates = (0, $fJmA9.handleConsecutiveTagTemplates)(readAndWriteTemplates);
            setState({
                uniqueKey: (0, $aXKmr.v4)(),
                readAndWriteTemplates: updatedTemplates,
                writeOnlyTemplates: updatedTemplates,
                caretPosition: {
                    templateIndex: caretPosition.templateIndex - 1,
                    characterIndex: 0
                },
                restoreFocus: true
            });
        } else // only text is deleted with DELETE or BACKSPACE
        setState({
            uniqueKey: (0, $aXKmr.v4)(),
            writeOnlyTemplates: readAndWriteTemplates,
            restoreFocus: true
        });
    };
const $e6cbbaf5c0cd93b7$export$a56e2c50ad04f20a = ()=>({ setState: setState })=>{
        const emptyTextWrapper = [
            (0, $kvPhw.initialTemplates)[0]
        ];
        setState({
            uniqueKey: (0, $aXKmr.v4)(),
            writeOnlyTemplates: emptyTextWrapper,
            readAndWriteTemplates: emptyTextWrapper,
            caretPosition: {
                templateIndex: 0,
                characterIndex: 0
            },
            restoreFocus: true
        });
    };
const $e6cbbaf5c0cd93b7$export$306cf5a0989ece24 = ()=>({ setState: setState })=>{
        const defaultTemplates = Array.from((0, $kvPhw.initialTemplates));
        setState({
            uniqueKey: (0, $aXKmr.v4)(),
            writeOnlyTemplates: defaultTemplates,
            // need hard refresh the state make it re-render
            readAndWriteTemplates: defaultTemplates,
            focusTagIndex: 0,
            // after reset, set the focus at the end of the input
            caretPosition: {
                templateIndex: $e6cbbaf5c0cd93b7$var$getPlaceHoldersLength(defaultTemplates),
                characterIndex: 0
            },
            restoreFocus: true,
            saveError: null
        });
    };
const $e6cbbaf5c0cd93b7$export$be1c83975a266890 = (templates)=>({ setState: setState })=>{
        const mergedTemplates = (0, $fJmA9.mergeConsecutiveTextTemplates)([
            ...templates
        ], true);
        const merged = mergedTemplates.length !== templates.length;
        if (merged) setState({
            uniqueKey: (0, $aXKmr.v4)(),
            readAndWriteTemplates: mergedTemplates,
            writeOnlyTemplates: mergedTemplates,
            focusTagIndex: 0,
            restoreFocus: true
        });
        else setState({
            readAndWriteTemplates: templates
        });
    };
const $e6cbbaf5c0cd93b7$export$97ab23b40042f8af = (caretPosition)=>({ setState: setState })=>{
        setState({
            caretPosition: caretPosition
        });
    };
const $e6cbbaf5c0cd93b7$export$93bd7e21ec24d5a4 = (placeholder)=>({ getState: getState, setState: setState })=>{
        const { readAndWriteTemplates: readAndWriteTemplates, caretPosition: caretPosition } = getState();
        // clone array as we use in-place modification of array
        // so sweet state can detect the change
        const modifiedTemplates = Array.from((0, $fJmA9.insertPlaceholderIntoState)(caretPosition, readAndWriteTemplates, placeholder));
        const updatedCaretPosition = {
            templateIndex: caretPosition.templateIndex + 1,
            characterIndex: 0
        };
        setState({
            uniqueKey: (0, $aXKmr.v4)(),
            readAndWriteTemplates: modifiedTemplates,
            writeOnlyTemplates: modifiedTemplates,
            focusTagIndex: 0,
            caretPosition: updatedCaretPosition,
            restoreFocus: true
        });
    };
const $e6cbbaf5c0cd93b7$export$2e7311d25c70abda = (placeholder, placeholderIndex, removedWithKeyboard)=>({ getState: getState, setState: setState })=>{
        const { readAndWriteTemplates: readAndWriteTemplates } = getState();
        // clone array as we use in-place modification of array
        // so sweet state can detect the change
        const modifiedTemplates = Array.from((0, $fJmA9.removePlaceholderFromState)(readAndWriteTemplates, placeholder, placeholderIndex, removedWithKeyboard));
        const updatedCaretPosition = (0, $fJmA9.getUpdatedCaretPosition)(placeholderIndex, readAndWriteTemplates, removedWithKeyboard);
        setState({
            uniqueKey: (0, $aXKmr.v4)(),
            readAndWriteTemplates: modifiedTemplates,
            writeOnlyTemplates: modifiedTemplates,
            focusTagIndex: 0,
            ...!removedWithKeyboard && {
                caretPosition: updatedCaretPosition,
                restoreFocus: true
            }
        });
    };
const $e6cbbaf5c0cd93b7$export$27f339617553b33b = (accountId, userInput, // eslint-disable-next-line @typescript-eslint/no-explicit-any
setState)=>{
    const userBranchSettings = $e6cbbaf5c0cd93b7$export$514aa7ab9be9e739(userInput);
    return (0, $e1hLY.setUserBranchConfigTemplates)(accountId, (0, $kvPhw.PROPERTY_KEY), userBranchSettings).then(()=>{
        setState({
            isSaving: false,
            originalTemplates: userBranchSettings
        });
        return true;
    }).catch((err)=>{
        setState({
            isSaving: false,
            saveError: err.message
        });
        return false;
    });
};
const $e6cbbaf5c0cd93b7$export$fdb7f1543a9fc37 = (accountId, setState)=>(0, $e1hLY.getUserBranchConfigTemplates)(accountId, (0, $kvPhw.PROPERTY_KEY)).then((res)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const initialState = $e6cbbaf5c0cd93b7$var$getInitialState(res);
        setState({
            ...initialState
        });
    }).catch(()=>{
        const initialState = $e6cbbaf5c0cd93b7$var$getInitialState((0, $kvPhw.initialTemplates));
        setState({
            ...initialState
        });
    });
const $e6cbbaf5c0cd93b7$export$5d8e34360f237a1b = (accountId, readAndWriteTemplates)=>({ setState: setState })=>{
        const { branchNameTemplate: branchNameTemplate, isGitCommandIncluded: isGitCommandIncluded } = $e6cbbaf5c0cd93b7$export$7d4957ca5a2b6c36(readAndWriteTemplates);
        setState({
            uniqueKey: (0, $aXKmr.v4)(),
            writeOnlyTemplates: branchNameTemplate,
            readAndWriteTemplates: branchNameTemplate,
            caretPosition: {
                templateIndex: $e6cbbaf5c0cd93b7$var$getPlaceHoldersLength(branchNameTemplate),
                characterIndex: 0
            },
            isSaving: true,
            saveError: null,
            focusTagIndex: 0,
            isGitCommandIncluded: isGitCommandIncluded
        });
        return $e6cbbaf5c0cd93b7$export$27f339617553b33b(accountId, readAndWriteTemplates, setState);
    };
const $e6cbbaf5c0cd93b7$export$7ca6c0c3719afbb8 = (accountId)=>({ setState: setState })=>{
        setState({
            isLoading: true
        });
        return $e6cbbaf5c0cd93b7$export$fdb7f1543a9fc37(accountId, setState);
    };
const $e6cbbaf5c0cd93b7$export$76dea67fbc11f21b = (branchData)=>({ setState: setState })=>{
        setState({
            branchData: branchData
        });
    };
const $e6cbbaf5c0cd93b7$export$23556ac160319730 = (focusTagIndex)=>({ setState: setState })=>{
        setState({
            focusTagIndex: focusTagIndex
        });
    };
const $e6cbbaf5c0cd93b7$export$e71e64a53e05e7a4 = (restoreFocus)=>({ setState: setState })=>{
        setState({
            restoreFocus: restoreFocus
        });
    };
const $e6cbbaf5c0cd93b7$export$6004d0b86f5fafd = (isGitCommandIncluded)=>({ setState: setState })=>{
        setState({
            isGitCommandIncluded: isGitCommandIncluded
        });
    };

});
parcelRegister("e1hLY", function(module, exports) {

$parcel$export(module.exports, "getUserBranchConfigTemplates", () => $80fbf8548a7339ff$export$12f2a339ce9f8976);
$parcel$export(module.exports, "setUserBranchConfigTemplates", () => $80fbf8548a7339ff$export$a881f7c12c765ce6);

var $FppkK = parcelRequire("FppkK");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");
const $80fbf8548a7339ff$export$12f2a339ce9f8976 = (accountId, propertyKey)=>accountId ? (0, $FppkK.getUserProperty)(accountId, propertyKey).catch((error)=>{
        // If we can't find key, we know user never save his branch config template
        if (error.statusCode === 404) return null;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('getUserBranchConfigTemplates', `Error reading data from getUserBranchConfigTemplates with property key ${propertyKey}`, error);
        return null;
    }) : new Promise((resolve)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('getUserBranchConfigTemplates', `Failed to get getUserBranchConfigTemplates with property key ${propertyKey} - no accountId`);
        return resolve(null);
    });
const $80fbf8548a7339ff$export$a881f7c12c765ce6 = (accountId, propertyKey, userBranchSettings)=>accountId ? (0, $FppkK.setUserProperties)(accountId, propertyKey, JSON.stringify(userBranchSettings)).then((res)=>{
        if (res.ok) return res;
        return res.text().then((errResp)=>{
            throw new (0, $1uIew.default)(res.status, errResp);
        });
    }).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('setUserBranchConfigTemplates', `Failed to update template value in setUserBranchConfigTemplates with property key ${propertyKey}`, error);
        throw new Error('Failed to save');
    }) : new Promise(()=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('setUserBranchConfigTemplates', `Failed to update template value in setUserBranchConfigTemplates with property key ${propertyKey} - no accountId`);
        throw new Error('No AccountId');
    });

});

parcelRegister("fJmA9", function(module, exports) {

$parcel$export(module.exports, "getUpdatedCaretPosition", () => $694006185786b75f$export$ebeb36435dbd8c09);
$parcel$export(module.exports, "handleConsecutiveTagTemplates", () => $694006185786b75f$export$d9ecd1b91ef53477);
$parcel$export(module.exports, "handleEndTagTemplate", () => $694006185786b75f$export$3e6ce6fb5d60fc32);
$parcel$export(module.exports, "mergeConsecutiveTextTemplates", () => $694006185786b75f$export$9b49bd5a514b024b);
$parcel$export(module.exports, "removePlaceholderFromState", () => $694006185786b75f$export$21882bab6686a4a1);
$parcel$export(module.exports, "insertPlaceholderIntoState", () => $694006185786b75f$export$8462f46c43e04a63);

var $fqICx = parcelRequire("fqICx");

var $3M949 = parcelRequire("3M949");
const $694006185786b75f$var$separatorTemplate = {
    type: (0, $3M949.BranchTemplateType).TEXT,
    value: '-'
};
const $694006185786b75f$var$textTemplate = (value)=>({
        type: (0, $3M949.BranchTemplateType).TEXT,
        value: value
    });
const $694006185786b75f$var$tagTemplate = (placeholder)=>({
        type: (0, $3M949.BranchTemplateType).PLACEHOLDER,
        value: placeholder
    });
const $694006185786b75f$var$insertAtFirstCharacterOfInput = (readAndWriteTemplates, placeholder)=>{
    // insert a separator after the tag
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(readAndWriteTemplates);
    if (newUserConfigTemplates.length > 1) newUserConfigTemplates[0].value = `${$694006185786b75f$var$separatorTemplate.value}${newUserConfigTemplates[0].value}`;
    newUserConfigTemplates.unshift($694006185786b75f$var$textTemplate(''), $694006185786b75f$var$tagTemplate(placeholder));
    return newUserConfigTemplates;
};
const $694006185786b75f$export$ebeb36435dbd8c09 = (placeholderIndex, previousTemplates, removedWithKeyboard)=>{
    const templateIndex = Math.ceil((placeholderIndex + 1) / 2) - 1;
    const previousTextTemplate = previousTemplates[placeholderIndex - 1];
    const currentTextTemplate = previousTemplates[placeholderIndex + 1];
    const characterIndexForRemovedViaCrossButton = previousTextTemplate.value.endsWith('-') && currentTextTemplate.value.length === 0 ? previousTextTemplate.value.length - 1 : previousTextTemplate.value.length;
    const characterIndex = removedWithKeyboard ? previousTextTemplate.value.length : characterIndexForRemovedViaCrossButton;
    return {
        templateIndex: templateIndex,
        characterIndex: characterIndex
    };
};
const $694006185786b75f$var$insertAtFirstCharacterAfterTag = (positionIndex, readAndWriteTemplates, placeholder)=>{
    // insert a separator before and after the tag
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(readAndWriteTemplates);
    const endText = readAndWriteTemplates[positionIndex].value;
    const endTextWithPrefix = endText.startsWith('-') || !endText ? endText : `-${endText}`;
    newUserConfigTemplates.splice(positionIndex, 1, $694006185786b75f$var$separatorTemplate, $694006185786b75f$var$tagTemplate(placeholder), $694006185786b75f$var$textTemplate(endTextWithPrefix));
    return newUserConfigTemplates;
};
const $694006185786b75f$export$d9ecd1b91ef53477 = (readAndWriteTemplates)=>{
    for(let i = 0; i < readAndWriteTemplates.length - 1; i += 1)if (readAndWriteTemplates[i].type === (0, $3M949.BranchTemplateType).PLACEHOLDER && readAndWriteTemplates[i + 1].type === (0, $3M949.BranchTemplateType).PLACEHOLDER) {
        readAndWriteTemplates.splice(i + 1, 0, $694006185786b75f$var$textTemplate(''));
        return readAndWriteTemplates;
    }
    return readAndWriteTemplates;
};
const $694006185786b75f$export$3e6ce6fb5d60fc32 = (readAndWriteTemplates)=>{
    const lastTemplate = readAndWriteTemplates[readAndWriteTemplates.length - 1];
    if (lastTemplate.type === (0, $3M949.BranchTemplateType).PLACEHOLDER) {
        readAndWriteTemplates.splice(readAndWriteTemplates.length, 0, $694006185786b75f$var$textTemplate(''));
        return readAndWriteTemplates;
    }
    return readAndWriteTemplates;
};
const $694006185786b75f$export$9b49bd5a514b024b = (readAndWriteTemplates, removedWithKeyboard)=>{
    for(let i = 0; i < readAndWriteTemplates.length - 1; i += 1)if (readAndWriteTemplates[i].type === (0, $3M949.BranchTemplateType).TEXT && readAndWriteTemplates[i + 1].type === (0, $3M949.BranchTemplateType).TEXT) {
        // merge the text of 2nd text node with the 1st node and
        // remove the 2nd text tag
        const beginText = readAndWriteTemplates[i].value;
        const endText = readAndWriteTemplates[i + 1].value;
        const beginTextEndWithSuffix = beginText.endsWith('-');
        const endTextStartWithPrefix = endText.startsWith('-');
        let finalSuffixedText;
        if (!beginText && endText && endTextStartWithPrefix) finalSuffixedText = endText.substring(1);
        else if (!endText && beginText && beginTextEndWithSuffix) finalSuffixedText = beginText.slice(0, -1);
        else if (beginTextEndWithSuffix && endTextStartWithPrefix) finalSuffixedText = beginText.slice(0, -1) + endText;
        else finalSuffixedText = beginText + endText;
        finalSuffixedText = finalSuffixedText === '--' ? '-' : finalSuffixedText;
        /**
			 * Keep hyphens when the tag was removed with keyboard to avoid jank
			 */ const finalText = removedWithKeyboard ? $694006185786b75f$var$textTemplate(`${beginText}${endText}`) : $694006185786b75f$var$textTemplate(finalSuffixedText);
        readAndWriteTemplates.splice(i, 2, finalText);
        return readAndWriteTemplates;
    }
    return readAndWriteTemplates;
};
const $694006185786b75f$var$insertInTheMiddle = (positionIndex, characterIndex, currentNodeText, readAndWriteTemplates, placeholder)=>{
    const beginText = currentNodeText.substring(0, characterIndex);
    const endText = currentNodeText.substring(characterIndex);
    const noPrefixRequired = endText.startsWith('-') || endText === '' && positionIndex === readAndWriteTemplates.length - 1;
    const beginTextWithSuffix = beginText.endsWith('-') ? beginText : `${beginText}-`;
    const endTextWithPrefix = noPrefixRequired ? endText : `-${endText}`;
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(readAndWriteTemplates);
    newUserConfigTemplates.splice(positionIndex, 1, $694006185786b75f$var$textTemplate(beginTextWithSuffix), $694006185786b75f$var$tagTemplate(placeholder), $694006185786b75f$var$textTemplate(endTextWithPrefix));
    return newUserConfigTemplates;
};
const $694006185786b75f$export$21882bab6686a4a1 = (originalTemplates, placeholderToRemove, placeholderIndex, removedWithKeyboard)=>{
    const readAndWriteTemplates = [
        ...originalTemplates
    ];
    for(let i = 0; i < readAndWriteTemplates.length; i += 1)if (readAndWriteTemplates[i].type === (0, $3M949.BranchTemplateType).PLACEHOLDER && readAndWriteTemplates[i].value === placeholderToRemove && i === placeholderIndex) {
        // we have reached the tag we want to remove
        readAndWriteTemplates.splice(i, 1);
        return $694006185786b75f$export$9b49bd5a514b024b(readAndWriteTemplates, removedWithKeyboard);
    }
    return readAndWriteTemplates;
};
const $694006185786b75f$export$8462f46c43e04a63 = (caretPosition, readAndWriteTemplates, placeholder)=>{
    let templatesYetToScan = caretPosition.templateIndex;
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(readAndWriteTemplates);
    for(let i = 0; i < newUserConfigTemplates.length; i += 1){
        if (templatesYetToScan === 0 && newUserConfigTemplates[i].type === (0, $3M949.BranchTemplateType).TEXT) {
            // we have reached the template we want to insert the new placeholder into
            if (caretPosition.templateIndex === 0 && caretPosition.characterIndex === 0) return $694006185786b75f$var$insertAtFirstCharacterOfInput(newUserConfigTemplates, placeholder);
            if (caretPosition.characterIndex === 0) return $694006185786b75f$var$insertAtFirstCharacterAfterTag(i, newUserConfigTemplates, placeholder);
            return $694006185786b75f$var$insertInTheMiddle(i, caretPosition.characterIndex, newUserConfigTemplates[i].value, newUserConfigTemplates, placeholder);
        }
        if (newUserConfigTemplates[i].type === (0, $3M949.BranchTemplateType).PLACEHOLDER) templatesYetToScan -= 1;
    }
    return newUserConfigTemplates;
};

});



parcelRegister("6Wpie", function(module, exports) {

$parcel$export(module.exports, "default", () => $f656c73c7102e202$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cA0Y2 = parcelRequire("cA0Y2");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $8pnTC = parcelRequire("8pnTC");

var $ewOxf = parcelRequire("ewOxf");

var $9ewtR = parcelRequire("9ewtR");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $806LH = parcelRequire("806LH");

var $2ZGUP = parcelRequire("2ZGUP");

var $3IF6p = parcelRequire("3IF6p");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8q7lT = parcelRequire("8q7lT");

var $kvPhw = parcelRequire("kvPhw");

var $363xp = parcelRequire("363xp");

var $3M949 = parcelRequire("3M949");

var $7gjNa = parcelRequire("7gjNa");

var $5L1GF = parcelRequire("5L1GF");

var $UyKz5 = parcelRequire("UyKz5");

var $9vDaV = parcelRequire("9vDaV");

var $hCNE8 = parcelRequire("hCNE8");

var $ljOJ6 = parcelRequire("ljOJ6");
const $f656c73c7102e202$var$TagComponent = ({ text: text, onClick: onClick, onKeyDown: onKeyDown, tagId: tagId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$SimpleTagWrapper, {
        onClick: onClick,
        tabIndex: 0,
        onKeyDown: onKeyDown,
        "data-testid": `development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.tag-component-${tagId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
        testId: "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.simple-tag",
        text: text,
        appearance: "rounded",
        color: "blueLight"
    }));
const $f656c73c7102e202$var$BranchCommandBuilder = ({ setIsBranchConfigOpen: setIsBranchConfigOpen })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isTemplateValid, setIsTemplateValid] = (0, $eJOHy.useState)(true);
    const [{ readAndWriteTemplates: readAndWriteTemplates, writeOnlyTemplates: writeOnlyTemplates, isSaving: isSaving, saveError: saveError, originalTemplates: originalTemplates, branchData: branchData }, { setDefaultTemplates: setDefaultTemplates, insertPlaceholder: insertPlaceholder, saveUserConfigBranchData: saveUserConfigBranchData, setInitialState: setInitialState }] = (0, $5L1GF.useBranchCommandBuilderStore)();
    const { projectKey: projectKey, issueKey: issueKey, issueSummary: issueSummary, issueType: issueType } = branchData;
    const branchSettings = (0, $7gjNa.getBranchTemplate)(readAndWriteTemplates);
    const { gitCommand: gitCommand } = (0, $ljOJ6.getGitCommand)(branchSettings, projectKey, issueKey, issueSummary, issueType);
    const inputRef = (0, $eJOHy.useRef)(null);
    const accountId = (0, $8q7lT.useAccountId)();
    const getAnalyticsAttributes = (templates)=>{
        const isIssueTitleUsed = templates.some((template)=>template.value === (0, $3M949.PlaceholderEnum).ISSUE_SUMMARY);
        const isIssueTypeUsed = templates.some((template)=>template.value === (0, $3M949.PlaceholderEnum).ISSUE_TYPE);
        const isProjectKeyUsed = templates.some((template)=>template.value === (0, $3M949.PlaceholderEnum).PROJECT_KEY);
        return {
            isIssueTitleUsed: isIssueTitleUsed,
            isIssueTypeUsed: isIssueTypeUsed,
            isProjectKeyUsed: isProjectKeyUsed
        };
    };
    const handleSave = (syntheticEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'updateBranchNameFormatSaved', getAnalyticsAttributes(writeOnlyTemplates));
        saveUserConfigBranchData(accountId, branchSettings).then((res)=>{
            res && setIsBranchConfigOpen(false);
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleTagOnInsert = (tagName, viaKeyboard = false)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'updateBranchNameFormatLabel'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
            labelName: tagName,
            viaKeyboard: viaKeyboard
        });
        insertPlaceholder(tagName);
    };
    const handleTagOnKeydown = (event, tagName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const keyboardEvent = event;
        if (keyboardEvent.key === (0, $kvPhw.ENTER) || keyboardEvent.keyCode === (0, $kvPhw.ENTER_KEY_CODE)) handleTagOnInsert(tagName, true);
    };
    const handleReset = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'reset',
            actionSubject: 'updateBranchNameFormat'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        return setDefaultTemplates();
    };
    const handleCancel = (syntheticEvent, analyticsEvent)=>{
        setInitialState(originalTemplates);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'updateBranchNameFormatCancelled');
        setIsBranchConfigOpen(false);
    };
    const getValidate = (0, $eJOHy.useCallback)((templates, errorMessage)=>{
        const isValid = templates.some((template)=>template.value === (0, $3M949.PlaceholderEnum).ISSUE_KEY && template.type === (0, $3M949.BranchTemplateType).PLACEHOLDER);
        if (!isValid && isTemplateValid) {
            // Just the first time not valid we fire the event
            const analyticsEvent = createAnalyticsEvent({
                action: 'blocked',
                actionSubject: 'updateBranchNameFormatSaving'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        }
        isTemplateValid !== isValid && setIsTemplateValid(isValid);
        return {
            isValid: isValid,
            errorMessage: errorMessage
        };
    }, [
        createAnalyticsEvent,
        isTemplateValid
    ]);
    const getValidateCallback = (0, $eJOHy.useCallback)(()=>getValidate(readAndWriteTemplates, formatMessage((0, $363xp.default).errorMessage)), [
        getValidate,
        readAndWriteTemplates,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$BranchCommandBuilderWrapper, {
        "data-testid": "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.title-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$SectionHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f656c73c7102e202$var$sectionTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2",
        testId: (0, $kvPhw.UPDATE_BRANCH_NAME_FORMAT_TITLE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f656c73c7102e202$var$smallHeadingStyles
    }, formatMessage((0, $363xp.default).configSectionTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$ResetButton, {
        "data-testid": (0, $kvPhw.RESET_BUTTON_TEST_ID),
        onClick: handleReset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8pnTC))), {
        label: formatMessage((0, $363xp.default).resetButtonLabel),
        color: "var(--ds-icon, #44546F)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            arrowleft: {
                callback: ()=>{}
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            arrowright: {
                callback: ()=>{}
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hCNE8.default), {
        templates: writeOnlyTemplates,
        getValidate: getValidateCallback,
        inputRef: inputRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$ConfigTabsDescription, null, formatMessage((0, $363xp.default).configTabsDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$ConfigTabsWrapper, {
        "data-testid": "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.config-tabs-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, (0, $kvPhw.tags).map((tag)=>{
        const message = (0, $363xp.default)[tag];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$TagComponent, {
            key: tag,
            text: formatMessage(message),
            onClick: ()=>handleTagOnInsert(tag),
            onKeyDown: (e)=>handleTagOnKeydown(e, tag),
            tagId: tag
        });
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$Divider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f656c73c7102e202$var$sectionTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2",
        testId: (0, $kvPhw.PREVIEW_TITLE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f656c73c7102e202$var$smallHeadingStyles
    }, formatMessage((0, $363xp.default).previewSectionTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9vDaV.default), {
        gitCommand: gitCommand
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f656c73c7102e202$var$ButtonGroupWrapper, null, saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $UyKz5.default), {
        testId: (0, $kvPhw.SAVE_ERROR_MESSAGE_TEST_ID),
        type: (0, $kvPhw.ERROR),
        alertMessage: formatMessage((0, $363xp.default).saveError)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        testId: (0, $kvPhw.CANCEL_BUTTON_TEST_ID),
        onClick: handleCancel
    }, formatMessage((0, $363xp.default).cancelButton)), isSaving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        appearance: "primary",
        isLoading: true
    }, formatMessage((0, $363xp.default).saveButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        testId: (0, $kvPhw.SAVE_BUTTON_TEST_ID),
        onClick: handleSave,
        isDisabled: !isTemplateValid
    }, formatMessage((0, $363xp.default).saveButton)))))));
};
var $f656c73c7102e202$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f656c73c7102e202$var$BranchCommandBuilder;
const $f656c73c7102e202$var$BranchCommandBuilderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$SectionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$SectionHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f656c73c7102e202$var$smallHeadingStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase'
});
const $f656c73c7102e202$var$sectionTitleStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginRight: 'space.0',
    marginBottom: 'space.100',
    marginLeft: 'space.0',
    fontWeight: "var(--ds-font-weight-bold, 700)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$ResetButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _bfhk18uv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _vn89yh40 _1ohhidpf _7ehi1vm4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$ConfigTabsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _1e0c1txw _1n261g80 _1myktlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$Divider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zludwz _19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$ButtonGroupWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahh9n0 _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$SimpleTagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _1npcidpf _1gicidpf _1e09idpf _1mspidpf _1at8idpf _hjaqv77o _1cjoidpf _1yg6v77o _nt751r31 _49pcglyw _1hvw1o36 _vn897vkz _1ohhidpf _7ehi1vm4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f656c73c7102e202$var$ConfigTabsDescription = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8pnTC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f331c8b661ffec$var$_react = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61f331c8b661ffec$var$_baseNew = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $61f331c8b661ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f331c8b661ffec$var$RetryIcon = (props)=>/*#__PURE__*/ $61f331c8b661ffec$var$_react.default.createElement($61f331c8b661ffec$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$61f331c8b661ffec$var$RetryIcon.displayName = 'RetryIcon';
var $61f331c8b661ffec$var$_default = module.exports.default = $61f331c8b661ffec$var$RetryIcon;

});

parcelRegister("363xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcbad88382b9ce3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");

var $3M949 = parcelRequire("3M949");
const $9dcbad88382b9ce3$var$issueKey = (0, $3M949.PlaceholderEnum).ISSUE_KEY;
const $9dcbad88382b9ce3$var$issueSummary = (0, $3M949.PlaceholderEnum).ISSUE_SUMMARY;
const $9dcbad88382b9ce3$var$issueSummaryShort = (0, $3M949.PlaceholderEnum).ISSUE_SUMMARY_SHORT;
const $9dcbad88382b9ce3$var$issueType = (0, $3M949.PlaceholderEnum).ISSUE_TYPE;
const $9dcbad88382b9ce3$var$projectKey = (0, $3M949.PlaceholderEnum).PROJECT_KEY;
var $9dcbad88382b9ce3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    configSectionTitle: {
        "id": "development-summary-branch.common.config-section-title",
        "defaultMessage": "Update branch name format"
    },
    configTabsDescription: {
        "id": "development-summary-branch.common.config-tabs-description",
        "defaultMessage": "Select fields to add"
    },
    [$9dcbad88382b9ce3$var$issueKey]: {
        "id": "development-summary-branch.common.issue-key",
        "defaultMessage": "Issue key"
    },
    [$9dcbad88382b9ce3$var$issueSummary]: {
        "id": "development-summary-branch.common.issue-summary",
        "defaultMessage": "Issue summary"
    },
    [$9dcbad88382b9ce3$var$issueSummaryShort]: {
        "id": "development-summary-branch.common.issue-summary-short",
        "defaultMessage": "Issue summary short"
    },
    [$9dcbad88382b9ce3$var$issueType]: {
        "id": "development-summary-branch.common.issue-type",
        "defaultMessage": "Issue type"
    },
    [$9dcbad88382b9ce3$var$projectKey]: {
        "id": "development-summary-branch.common.project-key",
        "defaultMessage": "Project key"
    },
    previewSectionTitle: {
        "id": "development-summary-branch.common.preview-section-title",
        "defaultMessage": "Preview"
    },
    resetButtonLabel: {
        "id": "development-summary-branch.common.reset-button-label",
        "defaultMessage": "Reset"
    },
    cancelButton: {
        "id": "development-summary-branch.common.cancel-button",
        "defaultMessage": "Cancel"
    },
    saveButton: {
        "id": "development-summary-branch.common.save-button",
        "defaultMessage": "Save"
    },
    errorMessage: {
        "id": "development-summary-branch.common.error-message",
        "defaultMessage": "You must include the Issue key field"
    },
    saveError: {
        "id": "development-summary-branch.common.save-error",
        "defaultMessage": "We couldn't save this branch name format. Try again."
    },
    copyPageGitCommandErrorMessage: {
        "id": "development-summary-branch.common.copy-page-git-command-error-message",
        "defaultMessage": "This command exceeds {maxLength} characters. To make it shorter, copy and edit the command when creating your branch."
    },
    gitCommandSettingDescription: {
        "id": "development-summary-branch.common.git-command-setting-description",
        "defaultMessage": "Include git command"
    }
});

});

parcelRegister("UyKz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d4c71fe7f11ade2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $jkYbX = parcelRequire("jkYbX");

var $kvPhw = parcelRequire("kvPhw");
const $4d4c71fe7f11ade2$var$ErrorAlert = ({ type: type, alertMessage: alertMessage, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d4c71fe7f11ade2$var$Wrapper, {
        "data-testid": testId
    }, type === (0, $kvPhw.ERROR) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d4c71fe7f11ade2$var$ErrorMessage, null, alertMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        spacing: "spacious",
        label: "warning",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d4c71fe7f11ade2$var$WarningMessage, null, alertMessage)));
var $4d4c71fe7f11ade2$export$2e2bcd8739ae039 = $4d4c71fe7f11ade2$var$ErrorAlert;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4d4c71fe7f11ade2$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvrv2br",
            __cmplp.className
        ])
    });
});
const $4d4c71fe7f11ade2$var$WarningMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l",
            __cmplp.className
        ])
    });
});
const $4d4c71fe7f11ade2$var$ErrorMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1tmw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9vDaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5909bace60784563$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");
const $5909bace60784563$var$GitCommandPreview = ({ gitCommand: gitCommand })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: gitCommand,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5909bace60784563$var$PreviewContainer, {
        "data-testid": "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.git-command-preview.preview-container"
    }, gitCommand));
var $5909bace60784563$export$2e2bcd8739ae039 = $5909bace60784563$var$GitCommandPreview;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5909bace60784563$var$PreviewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _1reo15vq _18m915vq _189eyh40 _1dqonqa1 _1h6dmuej _syaz1gjq _ca0q1l7b _u5f312x7 _n3td1l7b _19bv12x7 _1bto1l2s _1e0ccj1k _1yyjcs5v _sudp1e54 _c71l1ylp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hCNE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $565e00ee4a5f6f38$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");

var $lpMrC = parcelRequire("lpMrC");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kvPhw = parcelRequire("kvPhw");

var $363xp = parcelRequire("363xp");

var $3M949 = parcelRequire("3M949");

var $5L1GF = parcelRequire("5L1GF");

var $1e4Lq = parcelRequire("1e4Lq");

var $FFwZA = parcelRequire("FFwZA");

var $5bPeg = parcelRequire("5bPeg");

var $kZia0 = parcelRequire("kZia0");

var $9otbM = parcelRequire("9otbM");
const $565e00ee4a5f6f38$var$TemplateInput = ({ templates: templates, getValidate: getValidate, inputRef: inputRef })=>{
    const [{ readAndWriteTemplates: readAndWriteTemplates, uniqueKey: uniqueKey, focusTagIndex: focusTagIndex, restoreFocus: restoreFocus, caretPosition: caretPosition }, { setEmptyTextStarterTemplates: setEmptyTextStarterTemplates, setCaretPosition: setCaretPosition, setUserEnteredTemplate: setUserEnteredTemplate, setFocusTagIndex: setFocusTagIndex, setRestoreFocus: setRestoreFocus, removePlaceholder: removePlaceholder }] = (0, $5L1GF.useBranchCommandBuilderStore)();
    const [isValid, setIsValid] = (0, $eJOHy.useState)(true);
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)('');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        const { errorMessage: error, isValid: result } = getValidate();
        setErrorMessage(error);
        setIsValid(result);
        (0, $9otbM.changeEachLineLastTextElementStyle)(inputRef);
    }, [
        inputRef,
        getValidate
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onChange = (0, $eJOHy.useCallback)((event)=>{
        // this should support ctrl + z to revert
        setCaretPosition((0, $9otbM.getCaretPosition)(window, event, caretPosition));
        const userConfig = (0, $9otbM.buildTemplateFromEnteredInput)(event);
        setUserEnteredTemplate(userConfig);
    }, [
        setCaretPosition,
        setUserEnteredTemplate,
        caretPosition
    ]);
    const updateCaretPosition = (0, $eJOHy.useCallback)((event)=>{
        setCaretPosition((0, $9otbM.getCaretPosition)(window, event, caretPosition));
    }, [
        setCaretPosition,
        caretPosition
    ]);
    const handleKeyUp = (0, $eJOHy.useCallback)((event)=>{
        setCaretPosition((0, $9otbM.getCaretPosition)(window, event, caretPosition));
        // Click Tab key can automatically focus on the very beginning
        if (event.keyCode === (0, $kvPhw.TAB_KEY_CODE) || event.key === (0, $kvPhw.TAB)) focusTagIndex !== 0 && setFocusTagIndex(0);
        if ((0, $lpMrC.isFirefox)() && (event.keyCode === (0, $kvPhw.BACKSPACE_KEY_CODE) || event.key === (0, $kvPhw.BACKSPACE) || event.keyCode === (0, $kvPhw.DELETE_KEY_CODE) || event.key === (0, $kvPhw.DELETE))) {
            if ((0, $9otbM.isEmptyInput)(inputRef.current)) setEmptyTextStarterTemplates();
        }
    }, [
        setCaretPosition,
        inputRef,
        caretPosition,
        setEmptyTextStarterTemplates,
        focusTagIndex,
        setFocusTagIndex
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (restoreFocus) {
            (0, $9otbM.restoreCaretPosition)(window, document, inputRef.current, caretPosition);
            setRestoreFocus(false);
        }
    }, [
        restoreFocus,
        caretPosition,
        setRestoreFocus,
        inputRef
    ]);
    const handleOnFocus = (event)=>{
        const currentCaretPosition = (0, $9otbM.getCaretPosition)(window, event, caretPosition);
        if (currentCaretPosition === undefined) return;
        if (restoreFocus === false && focusTagIndex === 0 && event.target === inputRef.current) {
            // when add or remove tag, or click reset button should not fire the event
            const analyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'updateBranchNameFormatInput'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        }
    };
    const handleOnMouseDown = ()=>{
        focusTagIndex !== 0 && setFocusTagIndex(0);
    };
    const handleKeyDown = (event)=>{
        if (event.keyCode === (0, $kvPhw.TAB_KEY_CODE) || event.key === (0, $kvPhw.TAB)) focusTagIndex !== 0 && setFocusTagIndex(0);
        if (event.keyCode === (0, $kvPhw.ARROW_LEFT_KEY_CODE) || event.key === (0, $kvPhw.ARROW_LEFT)) {
            // Press left key to focus on a tag cross button
            if (caretPosition.characterIndex === 0 && focusTagIndex === 0) {
                event.preventDefault();
                setFocusTagIndex(caretPosition.templateIndex);
            } else if (focusTagIndex !== 0) {
                // Leave the tag cross button
                if (// Press right key to focus a tag cross button then press left key to leave
                readAndWriteTemplates[focusTagIndex * 2 - 2]?.value?.length === caretPosition.characterIndex) {
                    event.preventDefault();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (0, $9otbM.restoreCaretPosition)(window, document, inputRef.current, {
                        ...caretPosition,
                        templateIndex: focusTagIndex - 1 > 0 ? focusTagIndex - 1 : 0
                    });
                } else // Press left key to focus a tag cross button then leave normally
                (0, $9otbM.restoreCaretPosition)(window, document, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                inputRef.current, caretPosition);
                setCaretPosition({
                    templateIndex: focusTagIndex - 1,
                    characterIndex: readAndWriteTemplates[focusTagIndex * 2 - 2]?.value?.length || 0
                });
                setFocusTagIndex(0);
            } else setCaretPosition({
                ...caretPosition,
                characterIndex: caretPosition.characterIndex - 1
            });
        }
        if (event.keyCode === (0, $kvPhw.ARROW_RIGHT_KEY_CODE) || event.key === (0, $kvPhw.ARROW_RIGHT)) {
            if (readAndWriteTemplates[caretPosition.templateIndex * 2]?.value?.length === caretPosition.characterIndex && focusTagIndex === 0 && caretPosition.templateIndex < (readAndWriteTemplates.length - 1) / 2) {
                // Press right key to focus on a tag cross button
                event.preventDefault();
                setFocusTagIndex(caretPosition.templateIndex + 1);
            } else if (focusTagIndex !== 0) {
                // Leave the tag cross button
                if (caretPosition.characterIndex === 0) {
                    // Press left key to focus on a tag cross button then press right key to leave
                    event.preventDefault();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (0, $9otbM.restoreCaretPosition)(window, document, inputRef.current, {
                        ...caretPosition,
                        templateIndex: focusTagIndex
                    });
                } else // Press right key to focus a tag cross button then leave normally
                (0, $9otbM.restoreCaretPosition)(window, document, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                inputRef.current, caretPosition);
                setCaretPosition({
                    templateIndex: focusTagIndex,
                    characterIndex: 0
                });
                setFocusTagIndex(0);
            } else if (caretPosition.templateIndex < (readAndWriteTemplates.length - 1) / 2 || caretPosition.templateIndex === (readAndWriteTemplates.length - 1) / 2 && caretPosition.characterIndex < readAndWriteTemplates[readAndWriteTemplates.length - 1]?.value?.length) setCaretPosition({
                ...caretPosition,
                characterIndex: caretPosition.characterIndex + 1
            });
        }
        if (event.keyCode === (0, $kvPhw.ARROW_UP_KEY_CODE) || event.key === (0, $kvPhw.ARROW_UP)) {
            event.preventDefault();
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $9otbM.restoreCaretPosition)(window, document, inputRef.current, {
                templateIndex: 0,
                characterIndex: 0
            });
            focusTagIndex !== 0 && setFocusTagIndex(0);
        }
        if (event.keyCode === (0, $kvPhw.ARROW_DOWN_KEY_CODE) || event.key === (0, $kvPhw.ARROW_DOWN)) {
            event.preventDefault();
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $9otbM.restoreCaretPosition)(window, document, inputRef.current, {
                templateIndex: (readAndWriteTemplates.length - 1) / 2,
                characterIndex: readAndWriteTemplates[readAndWriteTemplates.length - 1].value.length
            });
            focusTagIndex !== 0 && setFocusTagIndex(0);
        }
        if (event.keyCode === (0, $kvPhw.ENTER_KEY_CODE) || event.key === (0, $kvPhw.ENTER)) {
            if (focusTagIndex !== 0) removePlaceholder(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event.target?.parentElement?.parentElement?.dataset?.key, focusTagIndex * 2 - 1, false);
            // avoid useless space when click enter
            event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bPeg.StyledInput), {
        contentEditable: true,
        suppressContentEditableWarning: true,
        role: "textbox",
        tabIndex: "0",
        onInput: onChange,
        onMouseUp: updateCaretPosition,
        onMouseDown: handleOnMouseDown,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        isValid: isValid,
        key: uniqueKey,
        innerRef: inputRef,
        onFocus: handleOnFocus,
        "data-testid": "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.template-input.styled-input",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onCopy: (event)=>event.preventDefault(),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onPaste: (event)=>event.preventDefault(),
        "aria-label": formatMessage((0, $363xp.default).configSectionTitle)
    }, templates.map((template, index)=>{
        if (template.type === (0, $3M949.BranchTemplateType).TEXT) {
            const id = `index-${index}-${(0, $3M949.BranchTemplateType).TEXT}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kZia0.default), {
                key: id,
                value: template.value,
                id: id
            });
        }
        if (template.type === (0, $3M949.BranchTemplateType).PLACEHOLDER) {
            const enumValue = (0, $1e4Lq.enumFromStringValue)((0, $3M949.PlaceholderEnum), template.value);
            if (enumValue !== undefined) {
                const id = `index-${index}-${(0, $3M949.BranchTemplateType).PLACEHOLDER}`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $FFwZA.default), {
                    id: id,
                    key: `index-${index}-${enumValue}`,
                    index: index,
                    value: enumValue,
                    focusTagIndex: focusTagIndex
                });
            }
        }
        return null;
    })), !isValid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), {
        testId: "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.template-input.error-message"
    }, errorMessage));
};
var $565e00ee4a5f6f38$export$2e2bcd8739ae039 = $565e00ee4a5f6f38$var$TemplateInput;

});
parcelRegister("1e4Lq", function(module, exports) {

$parcel$export(module.exports, "enumFromStringValue", () => $e66ddffd8a872dd4$export$26662a44f4dcc401);
// Typescript doesn't have reverse mapping from string value to enum, so we'll need
// to convert manually.
function $e66ddffd8a872dd4$export$26662a44f4dcc401(enumType, enumValue) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.values(enumType).includes(enumValue) ? enumValue : undefined;
}

});

parcelRegister("FFwZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59199c83db32fe5d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ar6fB = parcelRequire("ar6fB");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $363xp = parcelRequire("363xp");

var $5L1GF = parcelRequire("5L1GF");
const $59199c83db32fe5d$var$Placeholder = ({ value: value, index: index, focusTagIndex: focusTagIndex, id: id })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [, { removePlaceholder: removePlaceholder }] = (0, $5L1GF.useBranchCommandBuilderStore)();
    const placeHolderRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const button = placeHolderRef.current?.getElementsByTagName('button')[0];
        if (!button) return;
        // prevent tag 'x' button tab focus
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        button.tabIndex = -1;
        if ((index + 1) / 2 === focusTagIndex) button.focus();
    }, [
        focusTagIndex,
        index
    ]);
    return(// Use 'data' attributes later when constructing
    // a state from the DOM content
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59199c83db32fe5d$var$PlaceholderContainer, {
        id: id,
        contentEditable: false,
        "data-key": value,
        "data-index": index,
        ref: placeHolderRef,
        "data-testid": `development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.template-input.placeholder.tag-${value}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
        testId: "development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.template-input.placeholder.tag",
        text: formatMessage((0, $363xp.default)[value]),
        appearance: "rounded",
        color: "blueLight",
        isRemovable: true,
        removeButtonLabel: "dismiss",
        onAfterRemoveAction: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'updateBranchNameFormatLabelRemoved', {
                label: value
            });
            removePlaceholder(value, index, false);
        }
    })));
};
var $59199c83db32fe5d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $59199c83db32fe5d$var$Placeholder;
const $59199c83db32fe5d$var$PlaceholderContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwxidpf _otyrv77o _18u0idpf _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5bPeg", function(module, exports) {

$parcel$export(module.exports, "StyledInput", () => $b18430a5dfa6b111$export$a195049fd73b3fe2);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cdbP5 = parcelRequire("cdbP5");

var $dPMMf = parcelRequire("dPMMf");
const $b18430a5dfa6b111$export$a195049fd73b3fe2 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "xmoyjg-0"
})({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`,
    borderRadius: '1px',
    overflow: 'auto',
    transition: 'outline-color 0.3s, outline-color 0.3s ease-out',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $dPMMf.gridSize) * 4}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${(0, $dPMMf.gridSize) * 7}px`,
    boxSizing: 'border-box',
    alignItems: 'center',
    flexWrap: 'wrap',
    position: 'relative',
    '&:focus': {
        outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isValid: isValid })=>isValid ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $cdbP5.css)({
        outline: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
        '&:focus': {
            outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $cdbP5.css)({
        outline: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
        '&:focus': {
            outline: `2px solid ${"var(--ds-border-danger, #E2483D)"}`
        }
    }));

});

parcelRegister("kZia0", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f2e1b65c96c6d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lpMrC = parcelRequire("lpMrC");

var $5L1GF = parcelRequire("5L1GF");
const $58f2e1b65c96c6d1$var$TextValue = ({ value: value, id: id })=>{
    /**
   * https://bugzilla.mozilla.org/show_bug.cgi?id=1583209
   */ const textNodeRef = (0, $eJOHy.useRef)(null);
    const [observer, setObserver] = (0, $eJOHy.useState)(null);
    const [, { restoreFocusAfterDeletingAllText: restoreFocusAfterDeletingAllText }] = (0, $5L1GF.useBranchCommandBuilderStore)();
    const observerCallback = (0, $eJOHy.useCallback)((mutationRecords)=>{
        if (mutationRecords.length > 0 && mutationRecords[0].target.childNodes.length === 0 && mutationRecords[0].target.textContent === '') {
            /**
       * https://bugzilla.mozilla.org/show_bug.cgi?id=389321
       */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            textNodeRef.current?.appendChild(document.createElement('br'));
            restoreFocusAfterDeletingAllText();
        } else if (textNodeRef.current?.childElementCount && textNodeRef.current?.childElementCount > 1 && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        textNodeRef.current?.childNodes[0]?.tagName === 'BR' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        textNodeRef.current?.childNodes[1]?.tagName === 'BR') {
            const brs = textNodeRef.current.getElementsByTagName('br');
            for(let i = 0; i < brs.length; i += 1)textNodeRef.current.removeChild(brs[i]);
        }
    }, [
        restoreFocusAfterDeletingAllText
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const obs = new MutationObserver(observerCallback);
        setObserver(obs);
    }, [
        observerCallback,
        setObserver
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $lpMrC.isFirefox)()) return undefined;
        if (!observer) return undefined;
        if (!textNodeRef.current) return undefined;
        observer.observe(textNodeRef.current, {
            characterData: true,
            childList: true,
            subtree: true
        });
        return ()=>{
            if (observer) observer.disconnect();
        };
    }, [
        observer,
        textNodeRef
    ]);
    const textNodeContent = (0, $lpMrC.isFirefox)() && value === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null) : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58f2e1b65c96c6d1$var$TextValueWrapper, {
        "data-testid": `development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.template-input.text-value.text-value-wrapper-${id}`,
        ref: textNodeRef,
        id: id
    }, textNodeContent);
};
var $58f2e1b65c96c6d1$export$2e2bcd8739ae039 = $58f2e1b65c96c6d1$var$TextValue;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58f2e1b65c96c6d1$var$TextValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1tkegktf _1ul9yh40 _1e0c1o8l _1nmz9jpi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9otbM", function(module, exports) {

$parcel$export(module.exports, "isEmptyInput", () => $ae94f49170bbbb87$export$7eacddb318aeb0e9);
$parcel$export(module.exports, "buildTemplateFromEnteredInput", () => $ae94f49170bbbb87$export$a8ee3d62ba190c4c);
$parcel$export(module.exports, "getCaretPosition", () => $ae94f49170bbbb87$export$7d120213748299d3);
$parcel$export(module.exports, "restoreCaretPosition", () => $ae94f49170bbbb87$export$4cf0df1560d9730);
$parcel$export(module.exports, "changeEachLineLastTextElementStyle", () => $ae94f49170bbbb87$export$46a4d770c47cbb9a);

var $7jcpc = parcelRequire("7jcpc");

var $8dH3d = parcelRequire("8dH3d");

var $dCU5j = parcelRequire("dCU5j");

var $79hL0 = parcelRequire("79hL0");

var $6l8VH = parcelRequire("6l8VH");

var $lpMrC = parcelRequire("lpMrC");

var $kvPhw = parcelRequire("kvPhw");

var $3M949 = parcelRequire("3M949");
function $ae94f49170bbbb87$var$isInputNode(node) {
    return node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLDivElement && node.attributes.getNamedItem('role')?.value === 'textbox';
}
function $ae94f49170bbbb87$var$isTagNode(node) {
    return node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(node.dataset?.key);
}
function $ae94f49170bbbb87$var$isTextNode(node) {
    return node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(node.dataset?.key);
}
function $ae94f49170bbbb87$var$minOfLength(textLength, characterIndex) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6l8VH)))([
        textLength,
        characterIndex
    ]) ?? 0;
}
function $ae94f49170bbbb87$var$checkConsecutiveNodes(childNodes, previousCaretPosition, isGivenNodeType, templateType) {
    let lastNode = null;
    let hasConsecutiveNodes = false;
    let caretPosition = previousCaretPosition;
    let templateIndex = 0;
    if (!(0, $lpMrC.isFirefox)()) return {
        hasConsecutiveNodes: hasConsecutiveNodes,
        caretPosition: caretPosition
    };
    for(let i = 0; i < childNodes.length; i += 1){
        const childNode = childNodes[i];
        if ($ae94f49170bbbb87$var$isTagNode(childNode)) templateIndex += 1;
        if (lastNode !== null && isGivenNodeType(childNode) && isGivenNodeType(lastNode)) {
            hasConsecutiveNodes = true;
            const characterIndex = templateType === (0, $3M949.BranchTemplateType).TEXT ? lastNode.textContent?.length ?? 0 : 0;
            caretPosition = {
                templateIndex: templateIndex,
                characterIndex: characterIndex
            };
            break;
        }
        lastNode = childNode;
    }
    return {
        hasConsecutiveNodes: hasConsecutiveNodes,
        caretPosition: caretPosition
    };
}
function $ae94f49170bbbb87$var$checkConsecutiveTextNodes(childNodes, previousCaretPosition) {
    return $ae94f49170bbbb87$var$checkConsecutiveNodes(childNodes, previousCaretPosition, $ae94f49170bbbb87$var$isTextNode, (0, $3M949.BranchTemplateType).TEXT);
}
function $ae94f49170bbbb87$var$checkConsecutiveTagNodes(childNodes, previousCaretPosition) {
    return $ae94f49170bbbb87$var$checkConsecutiveNodes(childNodes, previousCaretPosition, $ae94f49170bbbb87$var$isTagNode, (0, $3M949.BranchTemplateType).PLACEHOLDER);
}
function $ae94f49170bbbb87$export$7eacddb318aeb0e9(inputElement) {
    if (inputElement === null) return false;
    return inputElement.childNodes.length === 1 && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    inputElement.childNodes[0].tagName === 'BR' || inputElement.childNodes.length === 0;
}
function $ae94f49170bbbb87$export$a8ee3d62ba190c4c(event) {
    let result = (0, (/*@__PURE__*/$parcel$interopDefault($79hL0)))(event.currentTarget.childNodes, (node)=>{
        if ($ae94f49170bbbb87$var$isTagNode(node)) return {
            type: (0, $3M949.BranchTemplateType).PLACEHOLDER,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: node.dataset.key
        };
        return {
            type: (0, $3M949.BranchTemplateType).TEXT,
            value: node.textContent ?? ''
        };
    });
    if (result.length === 0) result = [
        Array.from((0, $kvPhw.initialTemplates))[0]
    ];
    return result;
}
function $ae94f49170bbbb87$export$7d120213748299d3(window, event, previousCaretPosition) {
    const styledInputNode = event.currentTarget;
    const selection = window.getSelection();
    if (selection === null || selection?.rangeCount < 0) // can't find a focus or a selection, return the default position
    return {
        templateIndex: 0,
        characterIndex: 0
    };
    if (selection?.rangeCount === 0) return previousCaretPosition;
    const range = selection?.getRangeAt(0) || {};
    const { endContainer: selectedTextNode, endOffset: endOffset } = range;
    let templateIndex = 0;
    let characterIndex = 0;
    const { hasConsecutiveNodes: hasConsecutiveTextNodes, caretPosition: manualPosition } = $ae94f49170bbbb87$var$checkConsecutiveTextNodes(styledInputNode.childNodes, previousCaretPosition);
    if (hasConsecutiveTextNodes) return manualPosition;
    const { hasConsecutiveNodes: hasConsecutiveTagNodes, caretPosition: updatedCaretPosition } = $ae94f49170bbbb87$var$checkConsecutiveTagNodes(styledInputNode.childNodes, previousCaretPosition);
    if (hasConsecutiveTagNodes) return updatedCaretPosition;
    if ((0, $lpMrC.isFirefox)() && $ae94f49170bbbb87$var$isInputNode(selectedTextNode)) /**
		 * In Firefox, when you delete a tag with the DELETE button (instead of Backspace),
		 * the focus is set on the input tag itself and the range is no longer on the new text tag.
		 *
		 * So we can use the previous caret position to retain the focus at the correct place.
		 */ return previousCaretPosition;
    (0, (/*@__PURE__*/$parcel$interopDefault($7jcpc)))(styledInputNode.childNodes, (childNode)=>{
        if ($ae94f49170bbbb87$var$isTagNode(childNode)) {
            // we have reached a 'Tag' node, so reset character index as it's a new block
            // and increment template index
            templateIndex += 1;
            characterIndex = 0;
        } else if (// same text input node but with no text in it
        childNode.childNodes.length === 1 && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        childNode.childNodes[0].tagName === 'BR' && childNode === selectedTextNode) {
            characterIndex = 0;
            return false;
        } else if (childNode?.childNodes[0] === selectedTextNode || childNode === selectedTextNode) {
            // we have reached the end node, increment the index
            // until the end of the selected range
            characterIndex += endOffset;
            // return false to exit the 'each'
            return false;
        }
        return true;
    });
    return {
        templateIndex: templateIndex,
        characterIndex: characterIndex
    };
}
const $ae94f49170bbbb87$export$4cf0df1560d9730 = (window, document, inputElement, caretPosition)=>{
    const range = document.createRange();
    if (window === null || window === undefined || inputElement === null) // we can't restore caret position
    return;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(window.getSelection) || window.getSelection() === null) // we can't restore caret position
    return;
    const selection = window.getSelection();
    if (selection === null) return;
    let templatesYetToScan = caretPosition.templateIndex;
    for(let i = 0; i < inputElement.childNodes.length; i += 1){
        const node = inputElement.childNodes[i];
        if ($ae94f49170bbbb87$var$isTagNode(node)) templatesYetToScan -= 1;
        if (templatesYetToScan === 0) {
            let textNode = $ae94f49170bbbb87$var$isTagNode(node) ? inputElement.childNodes[i + 1] : node;
            if (textNode === undefined) textNode = inputElement.childNodes[i];
            if (textNode.childNodes.length > 0) {
                // node with text
                const characterPosition = $ae94f49170bbbb87$var$minOfLength(textNode.childNodes[0].textContent?.length ?? 0, caretPosition.characterIndex);
                range.setStart(textNode.childNodes[0], characterPosition);
                range.setEnd(textNode.childNodes[0], characterPosition);
            } else {
                // node without text
                const characterPosition = $ae94f49170bbbb87$var$minOfLength(textNode.textContent?.length ?? 0, caretPosition.characterIndex);
                range.setStart(textNode, characterPosition);
                range.setEnd(textNode, characterPosition);
            }
            selection.removeAllRanges();
            selection.addRange(range);
            break; // exit 'for' loop as we have found our text node to set the caret position on
        }
    }
};
const $ae94f49170bbbb87$export$46a4d770c47cbb9a = (inputRef)=>{
    const eachLineLastTextNode = [];
    const nodePosition = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    inputRef.current.childNodes.forEach((textNode)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const textElement = textNode;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const nodeId = textElement.getAttribute?.('id');
        // We use HTMLElement.offsetTop to differentiate between lines
        const nodeTop = textElement.offsetTop;
        nodePosition[nodeTop] = nodeId;
    });
    Object.values(nodePosition).forEach((elementId)=>{
        if (elementId?.includes((0, $3M949.BranchTemplateType).TEXT)) eachLineLastTextNode.push(elementId);
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    inputRef.current.childNodes.forEach((node)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const element = node;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const id = element.getAttribute?.('id');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const isLastTextNode = eachLineLastTextNode.includes(id);
        if (element?.style) element.style.flex = isLastTextNode ? 'auto' : 'none';
    });
};

});
parcelRegister("7jcpc", function(module, exports) {

module.exports = (parcelRequire("5spib"));

});

parcelRegister("6l8VH", function(module, exports) {

var $dbOsL = parcelRequire("dbOsL");

var $4nlgl = parcelRequire("4nlgl");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $49dba17da9719171$var$min(array) {
    return array && array.length ? $dbOsL(array, $d7YnM, $4nlgl) : undefined;
}
module.exports = $49dba17da9719171$var$min;

});
parcelRegister("4nlgl", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $32f9cdba3e7ab203$var$baseLt(value, other) {
    return value < other;
}
module.exports = $32f9cdba3e7ab203$var$baseLt;

});




parcelRegister("ljOJ6", function(module, exports) {

$parcel$export(module.exports, "getGitCommand", () => $1758e6e52fc90362$export$fab4d15f2b52d319);

var $4CEkC = parcelRequire("4CEkC");

var $2nlj2 = parcelRequire("2nlj2");

var $kvPhw = parcelRequire("kvPhw");

var $3M949 = parcelRequire("3M949");

var $7gjNa = parcelRequire("7gjNa");
const $1758e6e52fc90362$var$getTruncatedIssueTitle = (issueTitle)=>{
    const maxLengthToTruncate = 30;
    if (issueTitle.length <= maxLengthToTruncate) return issueTitle;
    // truncate without cutting a word
    return (0, (/*@__PURE__*/$parcel$interopDefault($2nlj2)))(issueTitle, {
        length: maxLengthToTruncate,
        omission: '',
        separator: /\s/
    });
};
const $1758e6e52fc90362$var$sanitizeBranchName = (branchName)=>branchName.trim().replace((0, $kvPhw.FORBIDDEN_GIT_BRANCH_EXPRESSIONS), '-').replace(/-{2,}/g, '-');
const $1758e6e52fc90362$export$fab4d15f2b52d319 = (userBranchSettings, projectKey, issueKey, issueTitle, issueType)=>{
    const templateReplacements = {
        [(0, $3M949.PlaceholderEnum).ISSUE_KEY]: issueKey,
        [(0, $3M949.PlaceholderEnum).ISSUE_SUMMARY]: (0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(issueTitle),
        [(0, $3M949.PlaceholderEnum).ISSUE_SUMMARY_SHORT]: (0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))($1758e6e52fc90362$var$getTruncatedIssueTitle(issueTitle)),
        [(0, $3M949.PlaceholderEnum).ISSUE_TYPE]: issueType?.toLowerCase(),
        [(0, $3M949.PlaceholderEnum).PROJECT_KEY]: projectKey
    };
    const { branchNameTemplate: branchNameTemplate } = (0, $7gjNa.getBranchSettings)(userBranchSettings);
    let branchName = '';
    branchNameTemplate.forEach((template)=>{
        if (template.type === (0, $3M949.BranchTemplateType).PLACEHOLDER) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const index = template.value;
            const translatedValue = templateReplacements[index];
            branchName += translatedValue;
        } else branchName += template.value;
    });
    // Replace spaces from any other template such as issue type
    const sanitizedBranchName = $1758e6e52fc90362$var$sanitizeBranchName(branchName);
    const gitCommandLength = sanitizedBranchName.length;
    const gitCommand = `${(0, $kvPhw.GIT_CHECKOUT_NEW_BRANCH)} ${sanitizedBranchName}`;
    return {
        gitCommand: gitCommand,
        gitCommandLength: gitCommandLength
    };
};

});


parcelRegister("aKj6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c6639663743d8bf$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $1Aiky = parcelRequire("1Aiky");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");

var $kvPhw = parcelRequire("kvPhw");

var $363xp = parcelRequire("363xp");

var $5L1GF = parcelRequire("5L1GF");

var $UyKz5 = parcelRequire("UyKz5");

var $ljOJ6 = parcelRequire("ljOJ6");
const $3c6639663743d8bf$var$CopyBranchCommand = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ originalTemplates: originalTemplates, branchData: branchData }] = (0, $5L1GF.useBranchCommandBuilderStore)();
    const { projectKey: projectKey, issueKey: branchConfigIssueKey, issueSummary: issueSummary, issueType: issueType } = branchData;
    const { gitCommand: gitCommand, gitCommandLength: gitCommandLength } = (0, $ljOJ6.getGitCommand)(originalTemplates, projectKey, branchConfigIssueKey, issueSummary, issueType);
    const suggestedBranchName = gitCommand;
    const isGitCommandLengthValid = gitCommandLength <= (0, $kvPhw.GIT_COMMAND_MAX_LENGTH);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        eventName: "createBranchCommand shown",
        attributes: {
            gitCommandLength: gitCommandLength
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Aiky.CopyTextField), {
        value: suggestedBranchName,
        onCopyClick: (_, analyticsEvent)=>{
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createBranchCommandCopyButton', {
                redirectToScmProviderPage: false,
                gitCommandLength: gitCommandLength
            });
        },
        "aria-label": "Copy branch command"
    }), !isGitCommandLengthValid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3c6639663743d8bf$var$GitCommandErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $UyKz5.default), {
        testId: (0, $kvPhw.COPY_PAGE_GIT_COMMAND_LENGTH_ERROR_MESSAGE_TEST_ID),
        type: (0, $kvPhw.WARNING),
        alertMessage: formatMessage((0, $363xp.default).copyPageGitCommandErrorMessage, {
            maxLength: (0, $kvPhw.GIT_COMMAND_MAX_LENGTH)
        })
    })));
};
var $3c6639663743d8bf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3c6639663743d8bf$var$CopyBranchCommand;
const $3c6639663743d8bf$var$GitCommandErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1Aiky", function(module, exports) {

$parcel$export(module.exports, "CopyTextField", () => $950b0ebe304d3fcc$export$90c50f13f5e8c8e3);
$parcel$export(module.exports, "CopyTextFieldWithLabel", () => $950b0ebe304d3fcc$export$e18e72b7cc9c2f26);

var $cdbP5 = parcelRequire("cdbP5");

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");

var $4TA31 = parcelRequire("4TA31");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $icTn1 = parcelRequire("icTn1");

var $lRq8t = parcelRequire("lRq8t");

var $gqafW = parcelRequire("gqafW");

var $bDwc9 = parcelRequire("bDwc9");
const $950b0ebe304d3fcc$var$handleTextFieldClick = ({ target: target })=>{
    // Selects the full contents of the input for single clicks. This check
    // preserves default click & drag functionality when selecting a portion of text.
    const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = target;
    if (selectionStart === selectionEnd || selectionStart === 0 && selectionEnd === value.length) target.select();
};
// Exporting for test purposes
var $950b0ebe304d3fcc$var$_StyledDiv = /*#__PURE__*/ (0, $cdbP5.default)("div")`${(0, $bDwc9.copyTextFieldWrapperStyles)}`;
var $950b0ebe304d3fcc$var$_StyledDiv2 = /*#__PURE__*/ (0, $cdbP5.default)("div").withConfig({
    componentId: "is2i2p-0"
})`${(0, $bDwc9.fieldWrapperStyles)}`;
const $950b0ebe304d3fcc$export$90c50f13f5e8c8e3 = ({ value: value, delay: delay = 100, onCopyClick: onCopyClick, id: id, 'aria-labelledby': ariaLabelledBy, 'aria-label': ariaLabel // used for testing purposes
 })=>{
    let tooltipLabel;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const inputRef = (0, $eJOHy.useRef)();
    const timeoutIdRef = (0, $eJOHy.useRef)();
    const [showCopiedTooltip, setShowCopiedTooltip] = (0, $eJOHy.useState)(false);
    const [copyFailed, setCopyFailed] = (0, $eJOHy.useState)(false);
    const handleCopyClick = (event, analyticsEvent)=>{
        onCopyClick && onCopyClick(event, analyticsEvent);
        setCopyFailed(false);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        inputRef && inputRef.current && inputRef.current.select();
        let success = false;
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            success = document.execCommand('copy');
            setShowCopiedTooltip(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setCopyFailed(true);
            success = false;
        }
        if (!success) setShowCopiedTooltip(false);
        timeoutIdRef.current = setTimeout(()=>{
            setShowCopiedTooltip(false);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(timeoutIdRef.current);
        }, 3000);
        event.currentTarget.focus();
    };
    const handleMouseLeave = ()=>{
        if (timeoutIdRef.current) {
            setShowCopiedTooltip(false);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(timeoutIdRef.current);
        }
    };
    if (showCopiedTooltip === true) tooltipLabel = formatMessage((0, $gqafW.default).copiedTooltipLabel);
    else if (copyFailed) tooltipLabel = formatMessage((0, $gqafW.default).copyFailedTooltipLabel);
    return(// @ts-expect-error Property 'css' does not exist on type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.ts(2322)
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($950b0ebe304d3fcc$var$_StyledDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($950b0ebe304d3fcc$var$_StyledDiv2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        id: id,
        testId: `platform-copy-text-field.textfield--${id || ''}`,
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        ref: inputRef,
        value: value,
        // @ts-expect-error - TS2322 - Type '({ target }: ChangeEvent<HTMLInputElement>) => void' is not assignable to type 'MouseEventHandler<HTMLInputElement>'.
        onClick: $950b0ebe304d3fcc$var$handleTextFieldClick,
        onMouseDown: (e)=>{
            // This prevents the cursor from jumping to the end of the input onMouseDown
            // caused by Atlaskit's Textfield focusing the underlying input onMouseDown
            // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'EventTarget'.
            e.target.blur();
        },
        onMouseUp: (e)=>{
            // Prevents flaky behaviour where text is de-selected onMouseUp
            e.preventDefault();
        },
        isReadOnly: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        tag: "span",
        delay: delay,
        content: tooltipLabel || '',
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icTn1.StyledButton), {
        onClick: handleCopyClick,
        onMouseLeave: handleMouseLeave,
        testId: `platform-copy-text-field.styled-button-${id || ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
        spacing: "spacious",
        label: formatMessage((0, $gqafW.default).copyIconLabel)
    })))));
};
const $950b0ebe304d3fcc$export$e18e72b7cc9c2f26 = ({ label: label, name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: name,
        label: label
    }, ({ fieldProps: { id: id, 'aria-labelledby': ariaLabelledBy } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($950b0ebe304d3fcc$export$90c50f13f5e8c8e3, {
            id: id,
            "aria-labelledby": ariaLabelledBy,
            ...props
        }));
var $950b0ebe304d3fcc$export$2e2bcd8739ae039 = $950b0ebe304d3fcc$export$90c50f13f5e8c8e3;

});
parcelRegister("gqafW", function(module, exports) {

$parcel$export(module.exports, "default", () => $132e41e3bad6ed3a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $132e41e3bad6ed3a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    copiedTooltipLabel: {
        "id": "platform-copy-text-field.copied-tooltip-label",
        "defaultMessage": "Copied!"
    },
    copyFailedTooltipLabel: {
        "id": "platform-copy-text-field.copy-failed-tooltip-label",
        "defaultMessage": "Copy failed!"
    },
    copyIconLabel: {
        "id": "platform-copy-text-field.copy-icon-label",
        "defaultMessage": "Copy icon"
    }
});

});

parcelRegister("bDwc9", function(module, exports) {

$parcel$export(module.exports, "copyTextFieldWrapperStyles", () => $d77b65423397edfd$export$9acbfd01fa817150);
$parcel$export(module.exports, "fieldWrapperStyles", () => $d77b65423397edfd$export$540e61204cc9de4);

var $dPMMf = parcelRequire("dPMMf");
const $d77b65423397edfd$export$9acbfd01fa817150 = `
    display: flex;
`;
const $d77b65423397edfd$export$540e61204cc9de4 = `
    flex-grow: 1;
    margin-right: ${(0, $dPMMf.gridSize)}px;
    // Override blue focus ring and white background colour on focus
    [data-ds--text-field--container] {
        &:focus-within {
            border-color: ${"var(--ds-border, #091E4224)"};
        }
    }
    [data-ds--text-field--input] {
        &:focus {
            background: ${"var(--ds-border, #091E4224)"};
        }
    }
`;

});



parcelRegister("bNTaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $abee66b6d9cf1812$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $abee66b6d9cf1812$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createBranchMessage: {
        "id": "development-summary-branch.create-branch-dropdown.create-branch-message",
        "defaultMessage": "Create branch in {remoteAppName}"
    },
    branchTargetsGroupTitle: {
        "id": "development-summary-branch.create-branch-dropdown.branch-targets-group-title",
        "defaultMessage": "Source code integration"
    },
    gitCommandGroupTitle: {
        "id": "development-summary-branch.create-branch-dropdown.git-command-group-title",
        "defaultMessage": "Git create & checkout a new branch"
    },
    configurableBranchCreateButtonLabel: {
        "id": "development-summary-branch.create-branch-dropdown.configurable-branch-create-button-label",
        "defaultMessage": "Update branch name format"
    }
});

});



$parcel$global.rlb("hzpoZ")
//# sourceMappingURL=create-branch-dropdown.d7460dc1.js.map
